import styled from 'styled-components';
import { Button } from '@cashfree-intl/coherent';

export const StyledButton = styled(Button)`
  width: 12.5rem;
`;

export const StyledButtonDanger = styled(Button)`
  width: 12.5rem;
  color: #cb2c2c !important;
`;
